//# sourceMappingURL=client.mjs.map
/// <reference types="./client.d.mts" />
import * as $promise from "../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $effect from "../../redraw_lustre/redraw/lustre/effect.mjs";
import {
  state as do_state,
  loginWithRedirect as do_login_with_redirect,
  loginWithPopup as do_login_with_popup,
  buildAuthorize as do_authorize,
  logout as do_logout,
  handleRedirect as do_handle_redirect,
  client as create,
  getTokenSilently as get_token_silently,
  onSessionExpired as on_session_expired,
} from "../auth0.ffi.mjs";
import * as $options from "../auth0/client/options.mjs";
import * as $user from "../auth0/client/user.mjs";
import { CustomType as $CustomType } from "../gleam.mjs";

export { create, get_token_silently, on_session_expired };

export class Login extends $CustomType {}
export const Msg$Login = () => new Login();
export const Msg$isLogin = (value) => value instanceof Login;

export class Logout extends $CustomType {}
export const Msg$Logout = () => new Logout();
export const Msg$isLogout = (value) => value instanceof Logout;

export class Authorize extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$Authorize = ($0) => new Authorize($0);
export const Msg$isAuthorize = (value) => value instanceof Authorize;
export const Msg$Authorize$0 = (value) => value[0];

export class Authorized extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const Msg$Authorized = ($0) => new Authorized($0);
export const Msg$isAuthorized = (value) => value instanceof Authorized;
export const Msg$Authorized$0 = (value) => value[0];

function get_state(client) {
  return $promise.map(
    do_state(client),
    (content) => {
      return $option.then$(
        content,
        (content) => {
          let _pipe = $decode.run(content[1], $user.decoder());
          let _pipe$1 = $result.map(
            _pipe,
            (_capture) => { return $pair.new$(content[0], _capture); },
          );
          let _pipe$2 = $result.map(
            _pipe$1,
            (var0) => { return new $option.Some(var0); },
          );
          return $result.unwrap(_pipe$2, new $option.None());
        },
      );
    },
  );
}

export function init(client, msg) {
  return $effect.from_(
    (_, _1, dispatch) => {
      let _pipe = get_state(client);
      let _pipe$1 = $promise.map(_pipe, msg);
      $promise.tap(_pipe$1, dispatch);
      return undefined;
    },
  );
}

export function login_with_redirect(client, msg) {
  return $effect.from_(
    (_, _1, dispatch) => {
      let _pipe = do_login_with_redirect(client);
      let _pipe$1 = $promise.await$(_pipe, (_) => { return get_state(client); });
      let _pipe$2 = $promise.map(_pipe$1, msg);
      $promise.tap(_pipe$2, dispatch);
      return undefined;
    },
  );
}

export function login_with_popup(client, msg) {
  return $effect.from_(
    (_, _1, dispatch) => {
      let _pipe = do_login_with_popup(client);
      let _pipe$1 = $promise.await$(_pipe, (_) => { return get_state(client); });
      let _pipe$2 = $promise.map(_pipe$1, msg);
      $promise.tap(_pipe$2, dispatch);
      return undefined;
    },
  );
}

export function authorize(client, redirect_uri) {
  return $effect.from_(
    (dispatch, _, _1) => {
      let _pipe = do_authorize(client, redirect_uri);
      let _pipe$1 = $promise.map(
        _pipe,
        (var0) => { return new Authorize(var0); },
      );
      $promise.tap(_pipe$1, dispatch);
      return undefined;
    },
  );
}

export function logout(client, msg) {
  return $effect.from_(
    (_, _1, dispatch) => {
      let _pipe = do_logout(client);
      let _pipe$1 = $promise.await$(_pipe, (_) => { return get_state(client); });
      let _pipe$2 = $promise.map(_pipe$1, msg);
      $promise.tap(_pipe$2, dispatch);
      return undefined;
    },
  );
}

export function handle_redirect(client, url, msg) {
  return $effect.from_(
    (_, _1, dispatch) => {
      let _pipe = do_handle_redirect(client, url);
      let _pipe$1 = $promise.await$(_pipe, (_) => { return get_state(client); });
      let _pipe$2 = $promise.map(_pipe$1, msg);
      $promise.tap(_pipe$2, dispatch);
      return undefined;
    },
  );
}
